module.exports = __webpack_public_path__ + "static/media/has_nothing.7d8ec54b.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/Punch/MyPunchCoupon/assets/has_nothing.png
// module id = 683
// module chunks = 0